import { ComponentPropsWithoutRef, useEffect, useRef, useState } from 'react';
import cn from 'classnames';

import { Props as TooltipProps } from '@/components/Tooltip';

type Props = {
  type?: TooltipProps['type'];
  onClick?: TooltipProps['onClick'];
} & ComponentPropsWithoutRef<'div'>;

const getClassname = (type?: TooltipProps['type']) => {
  if (!type) return '';
  if (Array.isArray(type)) return type.map((t) => `type_${t}`).join(' ');
  return `type_${type}`;
};

const TooltipWrapper = ({ type, onClick, children }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const tooltipRef = useRef<HTMLDivElement>(null);

  const openTooltip = () => {
    setIsOpen(true);
  };

  const closeTooltip = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    if (!tooltipRef.current || onClick) return;
    tooltipRef.current.addEventListener('mouseenter', openTooltip);
    tooltipRef.current.addEventListener('mouseleave', closeTooltip);

    return () => {
      if (!tooltipRef.current) return;
      tooltipRef.current.removeEventListener('mouseenter', openTooltip);
      tooltipRef.current.removeEventListener('mouseleave', closeTooltip);
    };
  }, []);

  return (
    <div ref={tooltipRef} onClick={onClick} className={cn('tooltip_g', getClassname(type), { tooltip_open: isOpen })}>
      {children}
    </div>
  );
};

export default TooltipWrapper;
